import { c as _c } from "react/compiler-runtime";
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
/** Only public, current terms are exposed; authenticated login does not require guest contacts. */
export function useFundingAuthenticationTerms(client) {
  const $ = _c(17);
  const cache = useQueryClient();
  let t0;
  if ($[0] !== client.cacheKey) {
    t0 = ["onramp", client.cacheKey, "authentication-terms"];
    $[0] = client.cacheKey;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== client) {
    t1 = async t2 => {
      const {
        signal
      } = t2;
      return (await client.getPayerStatus(signal)).consent;
    };
    $[2] = client;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      persist: false
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t0 || $[6] !== t1) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      retry: false,
      gcTime: 0,
      staleTime: 0,
      meta: t2
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const query = useQuery(t3);
  let t4;
  let t5;
  if ($[8] !== cache || $[9] !== client) {
    t4 = () => {
      const stop = () => cache.removeQueries({
        queryKey: ["onramp", client.cacheKey, "authentication-terms"]
      });
      const unregister = client.onDispose(stop);
      return () => {
        unregister();
        stop();
      };
    };
    t5 = [cache, client];
    $[8] = cache;
    $[9] = client;
    $[10] = t4;
    $[11] = t5;
  } else {
    t4 = $[10];
    t5 = $[11];
  }
  useEffect(t4, t5);
  const t6 = query.data ?? null;
  const t7 = query.isPending || query.isFetching;
  const t8 = query.isError || query.isSuccess && !query.data;
  let t9;
  if ($[12] !== query || $[13] !== t6 || $[14] !== t7 || $[15] !== t8) {
    t9 = {
      consent: t6,
      loading: t7,
      failed: t8,
      retry() {
        query.refetch();
      }
    };
    $[12] = query;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
}